/*
 * ===============================================================================================================
 *                                Copyright 2023, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
export const ASSIGN_ROLE = 'Assign Role';
export const ROLE = 'Role';
export const CANCEL_BTN_TEXT = 'Cancel';
export const ROLES_FETCH_ERROR = 'Error while fetching roles';
export const ROLE_ASSIGNMENT_SUCCESS = 'Role assigned to selected users successfully';
export const ROLE_ASSIGNMENT_FAILURE = 'Role assignment was unsuccessful for the users:';
